export enum DevicePlatform {
    MBB = 'MBB',
    MBB_ODP = 'MBB_ODP',
    WCAR = 'WCAR',
    UNKNOWN = 'UNKNOWN'
}